import { useFormikContext, getIn, FastField } from 'formik';
import { IconNames } from '@shipengine/giger-theme';
import { FormField, Checkbox } from '@shipengine/formik-giger';
import { Typography, Icon, IconSize } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { getFilterSectionStyles, getCategoryTitleStyles, getFilterSectionFieldStyles, getLabelWithIconStyles, getIconStyles } from './FilterSectionStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { getLengthValues } from '../../../utils/Filters.js';
import { checkIconName } from '../../../utils/Icon.js';

const FilterSection = _ref => {
  let {
    filters,
    titleKey,
    sectionName,
    children
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    values
  } = useFormikContext();
  const currentValues = getIn(values, sectionName);
  const total = getLengthValues(currentValues);
  const getFilterLabel = filter => {
    const {
      name,
      icon
    } = filter;
    if (!icon) {
      return name;
    }
    return jsxs("span", {
      css: getLabelWithIconStyles,
      children: [jsx(Icon, {
        name: IconNames[checkIconName(icon).toUpperCase().replace('-', '_')],
        size: IconSize.SIZE_SMALL,
        css: getIconStyles
      }), name]
    });
  };
  return jsxs("section", {
    css: getFilterSectionStyles,
    children: [jsx(Typography, {
      css: getCategoryTitleStyles(!!total),
      component: "h6",
      variant: "heading6",
      children: t(titleKey, {
        total: total ? `(${total})` : ''
      })
    }), filters.map(filter => jsx(FormField, {
      name: `${sectionName}.${filter.key}`,
      css: getFilterSectionFieldStyles,
      children: jsx(FastField, {
        component: Checkbox,
        name: `${sectionName}.${filter.key}`,
        label: getFilterLabel(filter)
      })
    }, filter.key)), children]
  });
};
FilterSection.displayName = 'FilterSection';

export { FilterSection, FilterSection as default };
//# sourceMappingURL=FilterSection.js.map
